module.exports = __webpack_public_path__ + "static/media/Business Plan-amico.8663c441.svg";